export default class Rol {
    constructor(name, pages, defaultRedirection, namedCode) {
        this.name = name;
        this.pages = pages;
        this.defaultRedirection = defaultRedirection;
        this.namedCode = namedCode;
    }
}